import { useStaticQuery, graphql } from "gatsby"

export const useQueryService = () => {
  const { allPrismicServices } = useStaticQuery(
    graphql`
      query QueryServices {
        allPrismicServices {
          nodes {
            data {
              banner {
                url
                alt
              }
              banner_title {
                html
                text
                raw
              }
              banner_description {
                html
                text
                raw
              }
              banner_button_label {
                html
                text
                raw
              }
              body {
                ... on PrismicServicesBodyMediaBox {
                  items {
                    title {
                      html
                      text
                      raw
                    }
                    description {
                      html
                      text
                      raw
                    }
                    image {
                      url
                      alt
                    }
                    link_label {
                      text
                    }
                    link {
                      url
                      type
                      link_type
                    }
                    shadow_color
                    image_position
                    email {
                      html
                      text
                      raw
                    }
                  }
                }
              }
              body1 {
                ... on PrismicServicesBody1ServicePackages {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    button_label {
                      html
                      text
                      raw
                    }
                    button_link {
                      url
                      type
                      link_type
                    }
                  }
                  items {
                    title {
                      html
                      text
                      raw
                    }
                    description {
                      html
                      text
                      raw
                    }
                    icon {
                      url
                      alt
                    }
                  }
                }
              }
              body2 {
                ... on PrismicServicesBody2Process {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    description {
                      html
                      text
                      raw
                    }
                  }
                  items {
                    process_step {
                      text
                    }
                  }
                }
              }
              body4 {
                ... on PrismicServicesBody4Reviews {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                  }
                  items {
                    avatar {
                      url
                      alt
                    }
                    name {
                      text
                    }
                    position {
                      text
                    }
                    comment {
                      html
                      text
                      raw
                    }
                  }
                }
              }
              body5 {
                ... on PrismicServicesBody5Offer {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    description {
                      html
                      text
                      raw
                    }
                  }
                  items {
                    offer {
                      document {
                        ... on PrismicCourseDetail {
                          uid
                          data {
                            banner_title {
                              html
                              text
                              raw
                            }
                            banner_description {
                              text
                              raw
                              html
                            }
                            owner {
                              document {
                                ... on PrismicPartners {
                                  data {
                                    logo {
                                      alt
                                      url
                                    }
                                  }
                                }
                              }
                            }
                            body {
                              ... on PrismicCourseDetailBodyAboutCourse {
                                id
                                primary {
                                  start_date(formatString: "MMMM DD")
                                  end_date(formatString: "MMMM DD, YYYY")
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              body6 {
                ... on PrismicServicesBody6Marketing {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    button_label {
                      html
                      text
                      raw
                    }
                    email_contact {
                      html
                      text
                      raw
                    }
                  }
                }
              }
              body7 {
                ... on PrismicServicesBody7GeneralCard {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    robot {
                      html
                      text
                      raw
                    }
                    image {
                      url
                      alt
                    }
                    googlebot {
                      html
                      text
                      raw
                    }
                    favicon {
                      alt
                      url
                    }
                    description {
                      html
                      text
                      raw
                    }
                    bingbot {
                      html
                      text
                      raw
                    }
                  }
                  slice_type
                }
                ... on PrismicServicesBody7OpenGraph {
                  primary {
                    og_url {
                      url
                      type
                      link_type
                    }
                    og_type {
                      html
                      text
                      raw
                    }
                    og_title {
                      html
                      text
                      raw
                    }
                    og_site_name {
                      html
                      text
                      raw
                    }
                    og_locale {
                      html
                      text
                      raw
                    }
                    og_image_width {
                      html
                      text
                      raw
                    }
                    og_image_height {
                      html
                      text
                      raw
                    }
                    og_image {
                      alt
                      url
                    }
                    og_description {
                      html
                      text
                      raw
                    }
                  }
                  slice_type
                }
                ... on PrismicServicesBody7TwitterCard {
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    image {
                      alt
                      url
                    }
                    description {
                      html
                      text
                      raw
                    }
                  }
                  slice_type
                }
                ... on PrismicServicesBody7PinterestProductPin {
                  slice_type
                  primary {
                    title {
                      html
                      text
                      raw
                    }
                    description {
                      html
                      text
                      raw
                    }
                    price
                    currency
                    availability
                  }
                }
              }
            }
          }
        }
      }
      `
  )

  return {
    allPrismicServices
  }
}